/** Parser for `GET /earn/vaults/:address/positions` — see {@link ../api/earn-allocations}. */

import { EarnVaultAllocationRowApi, EarnVaultAllocationsResponseApi } from "../api/earn-allocations";
import { EarnVaultAllocationRow, EarnVaultAllocationsResponse } from "../domain/earn-allocations";

export function parseEarnVaultAllocationRowFromApi(api: EarnVaultAllocationRowApi): EarnVaultAllocationRow {
    return {
        ...api,
        aumBase: BigInt(api.aumBase)
    };
}

export function parseEarnVaultAllocationsResponseFromApi(
    api: EarnVaultAllocationsResponseApi
): EarnVaultAllocationsResponse {
    return {
        ...api,
        items: api.items.map(parseEarnVaultAllocationRowFromApi)
    };
}
